import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";
import TechList from "../../components/TechList/TechList";
import VideoSection from "../../components/VideoSection/VideoSection";
import CmSlider from "../../components/CmSlider/CmSlider";
import MeetTheTeam from "../../components/MeetTheTeam/MeetTheTeam";
import BlogSlider from "../../components/BlogSlider/BlogSlider";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function HomePage() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Intro | TechFreelancX</title>
        <meta name="description" content="TechFreelanceX is group of independent professionals who will to  work on technology projects on a freelance basis." />
      </Helmet>
      <Header />
      <Hero animateText={true} />
      <VideoSection />
      <section className="text_block spacing">
        <div className="text_block_inner container">
          <div className="col-1">
            <p><u><b>TechFreelanceX</b></u> consists of independent professionals who will to  work on technology projects on a freelance basis. Our teams are made up of individuals who possess a wide range of skills & experience in various areas of technologies, such as <em>software development, web development, mobile app development, and digital marketing.</em> </p>`

            <Link className='animateLine' to='/about'>More about us</Link>


          </div>
        </div>
      </section >

      <CmSlider />
      <TechList />
      <MeetTheTeam />
      <BlogSlider />
      <Footer />
    </>
  );
}

export default HomePage;
